import { cn } from "@aircall/ds";
import { ChevronRight } from "@aircall/react-icons";

import { EvaluationPercentage } from "../EvaluationPercentage";

import { EvaluationAccordionHeaderContentProps } from ".";

export function EvaluationAccordionHeaderContent({
  title,
  maximumPoints: maxValue,
  points: value,
  disabled = false,
  // A single right-pointing chevron, vertically centered, that rotates to point
  // down when its accordion item is open. Rotation is driven by the DS
  // AccordionTrigger's `group/accordion-trigger` + aria-expanded (no JS state),
  // matching the pre-DS design.
  icon: Icon = (
    <ChevronRight className="size-6 shrink-0 text-muted-foreground transition-transform group-aria-expanded/accordion-trigger:rotate-90" />
  ),
  className,
  ...divProps
}: EvaluationAccordionHeaderContentProps) {
  return (
    <div
      className={cn(
        "flex flex-1 items-center justify-between gap-2 p-4",
        className
      )}
      {...divProps}
    >
      <p className="text-lg font-bold">{title}</p>
      <div className="flex items-center gap-2">
        {maxValue ? (
          <EvaluationPercentage
            points={value}
            maximumPoints={maxValue}
            disabled={disabled}
          />
        ) : null}
        {Icon}
      </div>
    </div>
  );
}
